module.exports = __webpack_public_path__ + "assets/img/1351587607248_.pic_hd.4cfd2c6d.jpg";